export function bigFrameDaysActive(promotion, now = Date.now()) {
    const start = Number(promotion?.starts_at), end = Number(promotion?.ends_at);
    return !!promotion?.enabled && Number.isFinite(start) && Number.isFinite(end)
        && end > start && now >= start * 1000 && now < end * 1000;
}

export function bigFrameDaysFilter(promotion, now = Date.now()) {
    if (!bigFrameDaysActive(promotion, now)) return 'frame_id:=-1';
    const time = Math.floor(now / 1000);
    const brands = (promotion.brand_ids || []).map(Number).filter(id => Number.isInteger(id) && id > 0);
    if (!brands.length) return 'frame_id:=-1';
    return [
        'luxottica_second_pair_participating:true',
        `luxottica_second_pair_starts_at:<=${time}`,
        `luxottica_second_pair_ends_at:>${time}`,
        `brand.brand_id:=[${brands.join(',')}]`,
        'frame.type_name:=[`Sunglasses`]',
    ].join(' && ');
}
